module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.defaultHeight),
    attrs: {
      "id": "startPage"
    }
  }, [_c('div', {
    staticClass: "headerMain"
  }, [_c('div', {
    staticClass: "top_logo inlineRight"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoImg,
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right_box inlineRight text-right"
  }, [_c('div', [_c('div', {
    staticClass: "customButton"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "userImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg,
      "alt": "exit",
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "customButton",
    on: {
      "click": _vm.changePsw
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "iconImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.pswImg,
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "customButton",
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v("退出")]), _vm._v(" "), _c('div', {
    staticClass: "iconImg"
  }, [_c('img', {
    attrs: {
      "src": _vm.exitImg,
      "alt": "exit",
      "height": "100%"
    }
  })])])])])]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "menuF"
  }, _vm._l((_vm.firstName), function(item, i) {
    return _c('div', {
      staticClass: "menuS",
      style: ({
        width: _vm.menuWidth
      })
    }, [_c('div', {
      staticClass: "menuT",
      staticStyle: {
        "margin-top": "50%"
      }
    }, [_c('div', {
      staticClass: "menuA",
      on: {
        "click": function($event) {
          return _vm.clickMenu(item.name)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72b1a607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/firstPage.vue
// module id = 1865
// module chunks = 502